import { action } from 'src/store/actions';

export const FETCH_LANDINGPAGE = 'FETCH_LANDINGPAGE';
export const REQUEST_LANDINGPAGE = 'REQUEST_LANDINGPAGE';
export const SUCCESS_LANDINGPAGE = 'SUCCESS_LANDINGPAGE';
export const FAILURE_LANDINGPAGE = 'FAILURE_LANDINGPAGE';

export const fetchLandingpage = (uuid: string) => action(FETCH_LANDINGPAGE, { uuid });
export const requestLandingpage = () => action(REQUEST_LANDINGPAGE);
export const requestLandingpageSuccess = (response: any) => action(SUCCESS_LANDINGPAGE, { response });
export const requestLandingpageFailure = (error: any) => action(FAILURE_LANDINGPAGE, { error });
